import {PropsWithChildren} from "react";
import {useSelf} from "../agent/useSelf.ts";
import {DispatchMeshWatcher} from "./dispatch.tsx";

export function DispatchMeshManager({children}: PropsWithChildren) {
    const {data: self} = useSelf();
    const canDispatch = self?.canDispatch;

    if (canDispatch) {
        return <DispatchMeshWatcher>{children}</DispatchMeshWatcher>;
    } else {
        return <>{children}</>;
    }
}